import { render } from "./presenca-do-aluno.vue?vue&type=template&id=339aa9b6&scoped=true"
import script from "./presenca-do-aluno.vue?vue&type=script&lang=js"
export * from "./presenca-do-aluno.vue?vue&type=script&lang=js"

import "./presenca-do-aluno.vue?vue&type=style&index=0&id=339aa9b6&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-339aa9b6"]])

export default __exports__